import { createLoginEvent } from '../eventCreators';
import { createLoginEventPayload } from '../dataHelpers/createLoginEventPayload';
import { isEmpty } from 'lodash';
import { clearAuthentication, logout, setAuthentication } from 'store/user/userActions';
import Cookies from 'universal-cookie';
import { COOKIE_NAMES } from 'lib/enums/cookies';
import { LOGIN_EVENT_EMITTED_KEY } from 'config';
import * as sessionStorage from 'lib/browser/sessionStorage';

const fireLoginEvent = (payload) => {
  const cookies = new Cookies();
  const qfValue = cookies.get(COOKIE_NAMES.QF_VALUE) || '';
  const userQffHash = qfValue || '';
  const loginEvent = createLoginEvent(
    createLoginEventPayload({
      userId: userQffHash,
      isLoggedIn: true,
      userPoints: payload?.pointsBalance,
      userQffHash,
    }),
  );

  if (window.dataLayer && loginEvent) {
    window.dataLayer.push(loginEvent);
  }
};

const checkForPageView = (payload) => {
  const hasPageView = window.dataLayer?.some((event) => (event as { event?: string }).event === 'page_view');

  if (hasPageView) {
    setTimeout(() => fireLoginEvent(payload), 0);
  } else {
    setTimeout(() => checkForPageView(payload), 50);
  }
};

const emitLoginEvent = ({ payload }) => {
  const lslUserId = payload?.memberId;
  const sessionKey = `${LOGIN_EVENT_EMITTED_KEY}_${lslUserId}`;
  const hasLoginEventBeenEmitted = sessionStorage?.get(sessionKey) === 'true';

  if (isEmpty(lslUserId) || hasLoginEventBeenEmitted) {
    return null;
  }

  sessionStorage?.set(sessionKey, 'true');

  if (typeof window !== 'undefined') {
    checkForPageView(payload);
  }

  return null;
};

const clearLoginEventTracking = () => {
  if (typeof window === 'undefined' || !window.sessionStorage) {
    return null;
  }

  Object.keys(window.sessionStorage).forEach((key) => {
    if (key.startsWith(LOGIN_EVENT_EMITTED_KEY)) {
      sessionStorage.remove(key);
    }
  });
  return null;
};

// eslint-disable-next-line
// @ts-ignore
export default { [setAuthentication]: emitLoginEvent, [logout]: clearLoginEventTracking, [clearAuthentication]: clearLoginEventTracking };
